// Скелетон на „Маркиране", докато се зареждат менюто/сметките: релса с
// маси-заготовки отляво + редове на поръчаното отдясно, с ОРАНЖЕВ спинер
// (pos-accent) вместо синия antd Spin. Размерите повтарят реалния изглед с
// маси в Ordering.tsx (ширина на релсата, грид на картите, карти-редове).

// Оранжев спинер — кръг с прозрачен горен сегмент, въртян от Tailwind
// animate-spin (без antd Spin, чийто цвят идва от синята тема).
export const OrangeSpinner = ({ label }: { label?: string }) => (
  <div className="flex flex-col items-center gap-3">
    <span
      aria-label="loading"
      className="w-9 h-9 rounded-full border-[3px] border-pos-accent border-t-transparent animate-spin"
    />
    {label && (
      <span className="text-sm font-semibold text-pos-dim">{label}</span>
    )}
  </div>
);

// Карта-заготовка на маса — повтаря формата на картата в TableList
// (rounded-[14px], min-h-[72px], име + долен ред със сума).
const TableCardSkeleton = () => (
  <div className="rounded-[14px] border-[1.5px] border-pos-line3 bg-pos-card p-[11px_14px] min-h-[72px] flex flex-col justify-between gap-2.5">
    <div className="h-4 w-2/3 rounded-md bg-pos-ctl/60" />
    <div className="flex items-center justify-between gap-2">
      <div className="h-3 w-1/3 rounded-md bg-pos-ctl/40" />
      <div className="h-3.5 w-1/4 rounded-md bg-pos-ctl/60" />
    </div>
  </div>
);

/** Скелетон на релсата с маси — ползва се и самостоятелно, докато bills се зареждат. */
export const TableRailSkeleton = () => (
  <div className="flex flex-col gap-2.5 p-3.5 animate-pulse">
    {/* търсачката над масите */}
    <div className="h-9 rounded-xl bg-pos-ctl/50" />
    <div className="grid grid-cols-[repeat(auto-fill,minmax(195px,1fr))] max-sm:grid-cols-1 gap-2.5">
      {Array.from({ length: 8 }).map((_, index) => (
        <TableCardSkeleton key={index} />
      ))}
    </div>
  </div>
);

// Ред-заготовка на поръчан продукт — повтаря картите в историята на масата
// (rounded-[10px], статус лента вляво, име + количество/цена).
const OrderRowSkeleton = () => (
  <div className="flex bg-pos-card border border-pos-line3 rounded-[10px] overflow-hidden">
    <span className="w-2.5 self-stretch bg-pos-ctl/40 shrink-0" />
    <div className="flex-1 px-3 py-[9px] flex items-center gap-3">
      <div className="h-3.5 flex-1 max-w-[55%] rounded-md bg-pos-ctl/60" />
      <div className="h-3 w-10 rounded-md bg-pos-ctl/40 ml-auto" />
      <div className="h-3.5 w-14 rounded-md bg-pos-ctl/60" />
    </div>
  </div>
);

/**
 * Скелетон на изгледа с маси (зареждане на менюто при отваряне на модула):
 * релса с маси отляво + поръчаното отдясно, а върху дясната половина —
 * оранжевият спинер с етикет. Рендира се ПОД истинския OrderingTopBar
 * (той не зависи от менюто и се показва веднага) — виж Ordering.tsx.
 */
export const OrderingSkeleton = ({ label }: { label?: string }) => (
  <div className="flex flex-1 overflow-hidden min-h-0">
    {/* релсата с маси — същите ширини като aside-а в Ordering.tsx */}
    <aside className="w-[124px] sm:w-44 lg:w-[clamp(340px,26%,470px)] flex-shrink-0 overflow-hidden bg-pos-panel border-r border-pos-line">
      <TableRailSkeleton />
    </aside>

    {/* поръчаното на избраната маса + спинерът върху него */}
    <main className="flex-1 relative overflow-hidden bg-pos-canvas">
      <div className="p-4 sm:p-6 flex flex-col gap-2.5 animate-pulse">
        <div className="h-5 w-44 rounded-md bg-pos-ctl/60 mb-1.5" />
        {Array.from({ length: 6 }).map((_, index) => (
          <OrderRowSkeleton key={index} />
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-pos-canvas/60">
        <OrangeSpinner label={label} />
      </div>
    </main>
  </div>
);
